import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import cn from 'classnames';
import {
	FormControl,
	FormControlLabel,
	RadioGroup,
	Radio,
	RadioGroupProps,
} from '@mui/material';
import { IOptionList } from 'models';

import { useStyles } from './CustomRadio.styles';

interface CustomRadioListProps extends RadioGroupProps {
	name: string;
	formTitle?: string;
	options?: IOptionList;
	wrapperClass?: string;
}

export const RegisteredRadioList = ({
	name,
	formTitle,
	options = [],
	wrapperClass,
}: CustomRadioListProps) => {
	const classes = useStyles();
	const { control } = useFormContext();

	const optionList = useMemo(
		() =>
			options.map(({ title, value: optionValue }) => (
				<FormControlLabel
					className={classes.radioListItem}
					key={optionValue}
					label={title}
					value={optionValue}
					control={<Radio color="primary" />}
				/>
			)),
		[classes, options],
	);

	return (
		<FormControl
			component="fieldset"
			className={cn(classes.radioList, wrapperClass)}
		>
			<p>{formTitle}</p>
			<Controller
				rules={{ required: true }}
				control={control}
				name={name}
				as={<RadioGroup>{optionList}</RadioGroup>}
			/>
		</FormControl>
	);
};
